var map = {
	"./google-play-badge-da-DK.svg": 55503,
	"./google-play-badge-de-DE.svg": 18157,
	"./google-play-badge-en-GB.svg": 34879,
	"./google-play-badge-en-US.svg": 97032,
	"./google-play-badge-es-ES.svg": 98255,
	"./google-play-badge-es-MX.svg": 72412,
	"./google-play-badge-fr-FR.svg": 37667,
	"./google-play-badge-it-IT.svg": 83477,
	"./google-play-badge-nb-NO.svg": 38382,
	"./google-play-badge-nl-NL.svg": 64603,
	"./google-play-badge-pl-PL.svg": 95199,
	"./google-play-badge-pt-BR.svg": 29791,
	"./google-play-badge-pt-PT.svg": 13007,
	"./google-play-badge-sv-SE.svg": 89822
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 31724;